import {api} from "@/shared/api";

import {BasicDataTable, BasicDataTableConfig, DataTableResponse, TypedColumnSettings} from "@/shared/ui/basicDataTable"
import {AddMobileDeviceDialog} from "@/features/user/addMobileDeviceDialog";
import * as Constants from "@/shared/constants";
import {DataTableContextMenu} from "@/shared/ui/dataTableContextMenu";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

interface MobileDevice {
	id: number;
	alias: string;
	/** ISO-8601 instant, e.g. "2026-07-13T08:34:49Z" (serialized from a backend java.time.Instant). */
	lastUsed: string;
}

export class MobileDevicesPage {

	private addMobileDeviceDialog: AddMobileDeviceDialog;
	private table: MobileDevicesTable;

	constructor() {
		this.addMobileDeviceDialog = new AddMobileDeviceDialog();
		this.table = new MobileDevicesTable({
			element: $("#connectedDevicesTable"),
			orderable: false,
			allowExpand: true,
			clampNote: true
		});
		$(this.table).on(BasicDataTable.EVENT_DATA_CHANGED, (e, terminal: DataTableResponse<MobileDevice>) => {
			const terminalsAvailable = terminal.recordsTotal > 0;
			$("#noConnectedDevicesPanel").toggle(!terminalsAvailable);
			$("#connectedDevicesPanel").toggle(terminalsAvailable);
		});
		$(".addMobileDeviceButton").click(() => this.addMobileDeviceDialog.open());
		$(this.addMobileDeviceDialog).on(AddMobileDeviceDialog.EVENT_ADDED_MOBILE_DEVICE, () => this.table.reload());
		$(this.table)
			.on(MobileDevicesTable.EVENT_MOBILE_DEVICE_REMOVE, (event, mobileDevice: MobileDevice) => {
				this.removeMobileDevice(mobileDevice);
			});
	}

	private removeMobileDevice(mobileDevice: MobileDevice) {
		BootstrapModal.confirm({
			title: "devices.context.remove",
			message: messages.withArguments("devices.confirm.remove", mobileDevice.alias),
			yesLabel: "confirmation.delete",
			yesAction: (modal) => {
				api("removeMobileDevice.json")
					.post({id: mobileDevice.id})
					.done(() => this.table.reload())
					.always(() => modal.close());
			},
			noLabel: "confirmation.cancel"
		});
	}
}

class MobileDevicesTable extends BasicDataTable<MobileDevice> {
	public static EVENT_MOBILE_DEVICE_REMOVE = "eventRemoveMobileDevice";

	constructor(config: BasicDataTableConfig) {
		super("/timr/connectedDevices.json", config);
	}

	protected createDataTableConfig(): DataTables.Settings {
		return {
			dom: `rt<"datatable-footer"ip>`,
			paging: true,
			serverSide: true,
			pageLength: Constants.ADMINISTRATION_MAIN_TABLES_PAGE_LENGTH
		};
	}

	protected getColumnSettings(): TypedColumnSettings<MobileDevice>[] {
		return [
			{data: "id", width: "44px", orderable: false, className: "context-menu", render: this.contextMenu.render},
			{data: "alias", orderable: true, render: BasicDataTable.renderText}
		];
	}

	protected createContextMenu() {
		return new DataTableContextMenu()
			.addMenuEntry({
				label: "devices.context.remove",
				action: model => { $(this).triggerHandler(MobileDevicesTable.EVENT_MOBILE_DEVICE_REMOVE, model); }
			});
	}

	protected getDefaultOrder(): (string | number)[][] {
		return [[1, "asc"]];
	}
}
